// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: grid;
  place-items: center;
  height: 100%;
}

.container {
  border: 1px solid var(--gc-border-color);
  background: var(--gc-color-primary-contrast);
  width: 95vw;
  max-width: 500px;
}

.content {
  padding: var(--wrapper-gap);
  display: grid;
  grid-template-rows: [header-start] auto [header-end config-input-start] auto [config-input-end controls-start] auto [controls-end error-start] auto [error-end];
  gap: var(--wrapper-gap);
}
.content .header {
  grid-row: header;
  display: grid;
  place-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--gc-border-color);
  margin: 0 calc(-1 * var(--wrapper-gap));
}
.content .header h1 {
  margin: 0.5rem 0;
}
.content .header p {
  margin: 0.25rem 0;
  color: var(--gc-text-color-secondary);
}
.content .config-input {
  grid-row: config-input;
  padding: var(--wrapper-gap);
}
.content .controls {
  grid-row: controls;
  padding: var(--wrapper-gap);
}
.content .error-message {
  grid-row: error;
  padding: var(--wrapper-gap);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/cashregister/config/cashregister-terminal-config.page.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AACF;;AACA;EACE,wCAAA;EACA,4CAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AAAA;EACE,2BAAA;EACA,aAAA;EACA,+JAAA;EACA,uBAAA;AAGF;AADE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,+CAAA;EACA,uCAAA;AAGJ;AADI;EACE,gBAAA;AAGN;AADI;EACE,iBAAA;EACA,qCAAA;AAGN;AADE;EACE,sBAAA;EACA,2BAAA;AAGJ;AADE;EACE,kBAAA;EACA,2BAAA;AAGJ;AADE;EACE,eAAA;EACA,2BAAA;AAGJ","sourcesContent":[":host\n  display: grid\n  place-items: center\n  height: 100%\n\n.container\n  border: 1px solid var(--gc-border-color)\n  background: var(--gc-color-primary-contrast)\n  width: 95vw\n  max-width: 500px\n\n.content\n  padding: var(--wrapper-gap)\n  display: grid\n  grid-template-rows: [header-start] auto [header-end config-input-start] auto [config-input-end controls-start] auto [controls-end error-start] auto [error-end]\n  gap: var(--wrapper-gap)\n  \n  .header\n    grid-row: header\n    display: grid\n    place-items: center\n    padding: 1rem\n    border-bottom: 1px solid var(--gc-border-color)\n    margin: 0 calc(-1 * var(--wrapper-gap))\n    \n    h1\n      margin: 0.5rem 0\n    \n    p\n      margin: 0.25rem 0\n      color: var(--gc-text-color-secondary)\n  \n  .config-input\n    grid-row: config-input\n    padding: var(--wrapper-gap)\n  \n  .controls\n    grid-row: controls\n    padding: var(--wrapper-gap)\n  \n  .error-message\n    grid-row: error\n    padding: var(--wrapper-gap)\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
